import React from 'react';
import { formatCurrency } from '@/components/tables/table-utils';
import { isNil } from 'lodash';

export function PricesTooltip({
  isReferralCommission,
  isAgencyMarkup
}: {
  isReferralCommission: boolean;
  isAgencyMarkup: boolean;
}) {
  if (isReferralCommission && isAgencyMarkup)
    return (
      <>
        Price, Gross Price, Effective Price, Unit Price, Effective Unit Price, and Referral Fee are{' '}
        <span className="font-bold">$0.00</span> for Zero Dollar line items
      </>
    );
  if (isReferralCommission)
    return (
      <>
        Price, Gross Price, Unit Price, and Referral Fee are{' '}
        <span className="font-bold">$0.00</span> for Zero Dollar line items
      </>
    );
  if (isAgencyMarkup)
    return (
      <>
        Price, Effective Price, Unit Price, and Effective Unit Price are{' '}
        <span className="font-bold">$0.00</span> for Zero Dollar line items
      </>
    );
  return (
    <>
      Price and Unit Price are <span className="font-bold">$0.00</span> for Zero Dollar line items
    </>
  );
}

export function MediaBudgetTooltip({
  estimated_units,
  unit_cost,
  unit_price_type_id
}: {
  estimated_units?: number;
  unit_cost?: number;
  unit_price_type_id?: number;
}) {
  if (isNil(estimated_units) || isNil(unit_cost)) return null;

  const unitType = unit_price_type_id === 1 ? ' / 1,000 for CPM' : '';
  return (
    <>
      Media Budget is calculated as{' '}
      <span className="font-bold">{estimated_units.toLocaleString()}</span> Estimated Units
      {unitType} * <span className="font-bold">{formatCurrency(unit_cost)}</span> Planned Unit Cost
      for Zero Dollar Line Items
    </>
  );
}

export function PlannedMarginTooltip() {
  return (
    <>
      Planned Margin is <span className="font-bold">N/A</span> for Zero Dollar line items. However,
      the line item’s cost will lower the Campaign’s Planned Margin
    </>
  );
}

export function EstimatedUnitsTooltip() {
  return (
    <>
      Estimated Units are <span className="font-bold">entered above</span> for Zero Dollar line
      items
    </>
  );
}
